module.exports = __webpack_public_path__ + "img/5-3.036a605c.svg";